import { createAction, handleActions } from 'redux-actions'
import { sendApiRequest } from 'utils/api'
import { getClientId } from 'utils/utils'

// Constants
export const GET_SITE_AUDITS_COUNT = 'GET_SITE_AUDITS_COUNT'
export const getSiteAuditCount = (search) => {
  return (dispatch, getState) => {
    dispatch(createAction(GET_SITE_AUDITS_COUNT)())
    const options = {}
    const clientId = getClientId(getState)
    options.where = {
      and: [
        { clientId }
      ]
    }
    if (search) {
      options.where.and.push(search)
    }
    sendApiRequest('SiteAudits/count', {
      accessToken: getState().auth.account.accessToken
    }, 'get', options).then((response) => {
      if (response.status === 'failure') {
        dispatch(getSiteAuditCountError(response))
      }
      if (response.status === 'success') {
        dispatch(getSiteAuditCountSuccess(response.data.count))
      }
    })
  }
}

export const GET_SITE_AUDITS_COUNT_SUCCESS = 'GET_SITE_AUDITS_COUNT_SUCCESS'
export const getSiteAuditCountSuccess = createAction(GET_SITE_AUDITS_COUNT_SUCCESS)

export const GET_SITE_AUDITS_COUNT_ERROR = 'GET_SITE_AUDITS_COUNT_ERROR'
export const getSiteAuditCountError = createAction(GET_SITE_AUDITS_COUNT_ERROR)

export const GET_SITE_AUDITS = 'GET_SITE_AUDITS'
export const getSiteAudits = (pageSize, pageNumber, search) => {
  return (dispatch, getState) => {
    const clientId = getClientId(getState)
    const options = {
      filter: {
        order: 'dateAudited DESC',
        where: {
          and: [
            { clientId }
          ]
        }
      }
    }
    if (pageSize !== 0) {
      options.filter.limit = pageSize
    }
    if (pageNumber !== 1) {
      options.filter.skip = (pageNumber - 1) * pageSize
    }
    if (search) {
      options.filter.where.and.push(search)
    }
    dispatch(createAction(GET_SITE_AUDITS)())
    sendApiRequest('SiteAudits', {
      accessToken: getState().auth.account.accessToken
    }, 'get', options).then((response) => {
      if (response.status === 'failure') {
        dispatch(getSiteAuditsError(response))
      }
      if (response.status === 'success') {
        dispatch(getSiteAuditsSuccess(response.data))
      }
    })
  }
}

export const GET_SITE_AUDITS_SUCCESS = 'GET_SITE_AUDITS_SUCCESS'
export const getSiteAuditsSuccess = createAction(GET_SITE_AUDITS_SUCCESS)

export const GET_SITE_AUDITS_ERROR = 'GET_SITE_AUDITS_ERROR'
export const getSiteAuditsError = createAction(GET_SITE_AUDITS_ERROR)

export const DELETE_SITE_AUDIT_BY_ID = 'DELETE_SITE_AUDIT_BY_ID'
export const deleteSiteAuditById = (id) => {
  return (dispatch, getState) => {
    dispatch(createAction(DELETE_SITE_AUDIT_BY_ID)())
    sendApiRequest(`SiteAudits/${id}`, {
      accessToken: getState().auth.account.accessToken
    }, 'delete').then((response) => {
      if (response.status === 'failure') {
        dispatch(deleteSiteAuditByIdError(response.data))
      }
      if (response.status === 'success') {
        dispatch(deleteSiteAuditByIdSuccess(response.data))
      }
    })
  }
}

export const DELETE_SITE_AUDIT_BY_ID_SUCCESS = 'DELETE_SITE_AUDIT_BY_ID_SUCCESS'
export const deleteSiteAuditByIdSuccess = createAction(DELETE_SITE_AUDIT_BY_ID_SUCCESS)

export const DELETE_SITE_AUDIT_BY_ID_ERROR = 'DELETE_SITE_AUDIT_BY_ID_ERROR'
export const deleteSiteAuditByIdError = createAction(DELETE_SITE_AUDIT_BY_ID_ERROR)

export const DELETE_SITE_AUDIT_BY_ID_RESET = 'DELETE_SITE_AUDIT_BY_ID_RESET'
export const deleteSiteAuditByIdReset = createAction(DELETE_SITE_AUDIT_BY_ID_RESET)

export const GET_SITE_AUDIT_BY_ID = 'GET_SITE_AUDIT_BY_ID'
export const getSiteAuditById = (id) => {
  return (dispatch, getState) => {
    dispatch(createAction(GET_SITE_AUDIT_BY_ID)())
    sendApiRequest(`SiteAudits/${id}`, {
      accessToken: getState().auth.account.accessToken
    }, 'get', {
      filter: {
        include: ['checklistStatuses']
      },
      accessToken: getState().auth.account.accessToken
    }).then((response) => {
      if (response.status === 'failure') {
        dispatch(getSiteAuditByIdError(response))
      }
      if (response.status === 'success') {
        dispatch(getSiteAuditByIdSuccess(response.data))
      }
    })
  }
}

export const GET_SITE_AUDIT_BY_ID_SUCCESS = 'GET_SITE_AUDIT_BY_ID_SUCCESS'
export const getSiteAuditByIdSuccess = createAction(GET_SITE_AUDIT_BY_ID_SUCCESS)

export const GET_SITE_AUDIT_BY_ID_ERROR = 'GET_SITE_AUDIT_BY_ID_ERROR'
export const getSiteAuditByIdError = createAction(GET_SITE_AUDIT_BY_ID_ERROR)

export const GET_SITE_AUDIT_BY_ID_RESET = 'GET_SITE_AUDIT_BY_ID_RESET'
export const getSiteAuditByIdReset = createAction(GET_SITE_AUDIT_BY_ID_RESET)

export const GET_SITE_AUDIT_CHECKLIST_ITEMS = 'GET_SITE_AUDIT_CHECKLIST_ITEMS'
export const getSiteAuditChecklistItems = () => {
  return (dispatch, getState) => {
    dispatch(createAction(GET_SITE_AUDIT_CHECKLIST_ITEMS)())
    sendApiRequest(`ChecklistItems`, {
      accessToken: getState().auth.account.accessToken
    }, 'get').then((response) => {
      if (response.status === 'failure') {
        dispatch(getSiteAuditChecklistItemsError(response))
      }
      if (response.status === 'success') {
        dispatch(getSiteAuditChecklistItemsSuccess(response.data))
      }
    })
  }
}

export const GET_SITE_AUDIT_CHECKLIST_ITEMS_SUCCESS = 'GET_SITE_AUDIT_CHECKLIST_ITEMS_SUCCESS'
export const getSiteAuditChecklistItemsSuccess = createAction(GET_SITE_AUDIT_CHECKLIST_ITEMS_SUCCESS)

export const GET_SITE_AUDIT_CHECKLIST_ITEMS_ERROR = 'GET_SITE_AUDIT_CHECKLIST_ITEMS_ERROR'
export const getSiteAuditChecklistItemsError = createAction(GET_SITE_AUDIT_CHECKLIST_ITEMS_ERROR)

// Initial State
const initialState = {
  siteAuditCount: 0,
  isGettingSiteAudits: false,
  hasGottenSiteAudits: false,
  siteAudits: [],
  getSiteAuditsError: {},
  isDeletingSiteAudit: false,
  hasDeletedSiteAudit: false,
  deleteSiteAuditSuccess: {},
  deleteSiteAuditError: {},
  selectedSiteAudit: {},
  isGettingSiteAudit: false,
  hasGottenSiteAudit: false,
  getSiteAuditError: {},
  checklistStatuses: [],
  isGettingSiteAuditChecklistItems: false,
  hasGottenSiteAuditChecklistItems: false,
  getSiteAuditChecklistItemsError: {},
  getSiteAuditChecklistItemsSuccess: {},
  siteAuditChecklistItems: []
}

// Reducer
export default handleActions({
  [GET_SITE_AUDITS]: (state) => ({
    ...state,
    isGettingSiteAudits: true,
    hasGottenSiteAudits: false
  }),

  [GET_SITE_AUDITS_SUCCESS]: (state, { payload }) => ({
    ...state,
    isGettingSiteAudits: false,
    hasGottenSiteAudits: true,
    siteAudits: payload
  }),

  [GET_SITE_AUDITS_ERROR]: (state, { payload }) => ({
    ...state,
    isGettingSiteAudits: false,
    hasGottenSiteAudits: false,
    getSiteAuditsError: payload
  }),

  [GET_SITE_AUDITS_COUNT_SUCCESS]: (state, { payload }) => ({
    ...state,
    siteAuditCount: payload
  }),

  [DELETE_SITE_AUDIT_BY_ID]: (state) => ({
    ...state,
    isDeletingSiteAudit: true,
    hasDeletedSiteAudit: false
  }),

  [DELETE_SITE_AUDIT_BY_ID_SUCCESS]: (state, { payload }) => ({
    ...state,
    isDeletingSiteAudit: false,
    hasDeletedSiteAudit: true,
    deleteSiteAuditSuccess: payload
  }),

  [DELETE_SITE_AUDIT_BY_ID_ERROR]: (state, { payload }) => ({
    ...state,
    isDeletingSiteAudit: false,
    hasDeletedSiteAudit: false,
    deleteSiteAuditError: payload
  }),

  [DELETE_SITE_AUDIT_BY_ID_RESET]: (state) => ({
    ...state,
    isDeletingSiteAudit: false,
    hasDeletedSiteAudit: false,
    deleteSiteAuditError: {},
    deleteSiteAuditSuccess: {}
  }),

  [GET_SITE_AUDIT_BY_ID]: (state) => ({
    ...state,
    isGettingSiteAudit: true,
    hasGottenSiteAudit: false
  }),

  [GET_SITE_AUDIT_BY_ID_SUCCESS]: (state, { payload }) => ({
    ...state,
    isGettingSiteAudit: false,
    hasGottenSiteAudit: true,
    selectedSiteAudit: payload,
    checklistStatuses: payload.checklistStatuses || []
  }),

  [GET_SITE_AUDIT_BY_ID_ERROR]: (state, { payload }) => ({
    ...state,
    isGettingSiteAudit: false,
    hasGottenSiteAudit: false,
    getSiteAuditError: payload
  }),

  [GET_SITE_AUDIT_BY_ID_RESET]: (state) => ({
    ...state,
    isGettingSiteAudit: false,
    hasGottenSiteAudit: false,
    selectedSiteAudit: {},
    checklistStatuses: []
  }),

  [GET_SITE_AUDIT_CHECKLIST_ITEMS]: (state) => ({
    ...state,
    isGettingSiteAuditChecklistItems: true,
    hasGottenSiteAuditChecklistItems: false
  }),

  [GET_SITE_AUDIT_CHECKLIST_ITEMS_SUCCESS]: (state, { payload }) => ({
    ...state,
    isGettingSiteAuditChecklistItems: false,
    hasGottenSiteAuditChecklistItems: true,
    siteAuditChecklistItems: payload
  }),

  [GET_SITE_AUDIT_CHECKLIST_ITEMS_ERROR]: (state) => ({
    ...state,
    isGettingSiteAuditChecklistItems: false,
    hasGottenSiteAuditChecklistItems: false
  })
}, initialState) 